import { DocItem } from './doc-item';

export function generateDocItems(data, items, options) {
  items = items || [];
  _.forEach(data, item => {
    if (_.has(item, 'cid')) {
      items.push(new DocItem(item, options));
    }
    if (_.has(item, 'children')) {
      return generateDocItems(item.children, items, options);
    }
  });
  return items;
}
